import { FC, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import type { BatteryType } from '@/hooks/useBatteryContainers';

interface AddStockBatteryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  batteryTypes: BatteryType[];
  onSubmit: (data: {
    battery_type_id: string;
    serial_number?: string;
    notes?: string;
  }) => void;
}

export const AddStockBatteryModal: FC<AddStockBatteryModalProps> = ({
  open,
  onOpenChange,
  batteryTypes,
  onSubmit,
}) => {
  const [batteryTypeId, setBatteryTypeId] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [notes, setNotes] = useState('');

  const handleSubmit = () => {
    if (!batteryTypeId) return;

    onSubmit({
      battery_type_id: batteryTypeId,
      serial_number: serialNumber || undefined,
      notes: notes || undefined,
    });

    // Reset form
    setBatteryTypeId('');
    setSerialNumber('');
    setNotes('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Batterij toevoegen aan voorraad</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Batterij Type *</Label>
            <Select value={batteryTypeId} onValueChange={setBatteryTypeId}>
              <SelectTrigger>
                <SelectValue placeholder="Selecteer type" />
              </SelectTrigger>
              <SelectContent>
                {batteryTypes.map((type) => (
                  <SelectItem key={type.id} value={type.id}>
                    {type.name} ({type.power_kw}kW / {type.capacity_kwh}kWh)
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>Serienummer</Label>
            <Input
              value={serialNumber}
              onChange={(e) => setSerialNumber(e.target.value)}
              placeholder="Optioneel"
            />
          </div>

          <div>
            <Label>Notities</Label>
            <Textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Optionele notities"
              rows={3}
            />
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Annuleren
            </Button>
            <Button onClick={handleSubmit} disabled={!batteryTypeId}>
              Toevoegen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
